import type { Comm } from '../types';
import styles from './CommsLog.module.css';

/** Shared comms log. SYSTEM entries (auto-written by the app/cron) render subtly. */
export function CommsLog({ rows, loading }: { rows: Comm[]; loading?: boolean }) {
    if (loading) return <p className={styles.empty}>Loading…</p>;
    if (rows.length === 0) return <p className={styles.empty}>No comms logged yet.</p>;
    return (
        <ul className={styles.log}>
            {rows.map((c) => (
                <li key={c.id} className={c.comm_type === 'SYSTEM' ? styles.system : undefined}>
                    <span className={styles.meta}>
                        {c.comm_date} · {c.comm_type}
                        {c.by_user_name ? ` · ${c.by_user_name}` : ''}
                    </span>
                    <span className={styles.summary}>{c.summary}</span>
                </li>
            ))}
        </ul>
    );
}
